var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18Z",
    fill: "url(#paint0_linear_185_9453)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 12.6667H17.6667C18.125 12.6667 18.5 12.2917 18.5 11.8333C18.5 11.375 18.125 11 17.6667 11H12.6667C11.75 11 11 11.75 11 12.6667V24.3333C11 25.25 11.75 26 12.6667 26H17.6667C18.125 26 18.5 25.625 18.5 25.1667C18.5 24.7083 18.125 24.3333 17.6667 24.3333H12.6667V12.6667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7083 18.2084L23.3833 15.8834C23.3254 15.8238 23.251 15.7829 23.1696 15.7659C23.0883 15.7489 23.0038 15.7566 22.9268 15.7879C22.8498 15.8192 22.784 15.8728 22.7376 15.9417C22.6913 16.0107 22.6666 16.0919 22.6667 16.175V17.6667H16.8333C16.375 17.6667 16 18.0417 16 18.5C16 18.9584 16.375 19.3334 16.8333 19.3334H22.6667V20.825C22.6667 21.2 23.1167 21.3834 23.375 21.1167L25.7 18.7917C25.8667 18.6334 25.8667 18.3667 25.7083 18.2084Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_185_9453",
    x1: -1.73673e-7,
    y1: 18,
    x2: 36,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#736BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9892DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6bda1c97afde30c25f8fbd26390f9392.svg";
export { ForwardRef as ReactComponent };